import axios, { AxiosResponse } from 'axios'
import { IPersonnelModel } from './PersonnelModel';
import { ApiResponse, PageResponse } from '../../../../shared/models/ApiModels'

// Base URL ayarı
const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

//  BASE URL 
export const PERSONNEL_CREATE_URL = `${API_URL}api/v1/definition/personnel/create`;
export const PERSONNEL_GET_ALL_URL = `${API_URL}api/v1/definition/personnel/all`;
export const PERSONNEL_DELETE_URL = `${API_URL}api/v1/definition/personnel/delete/`;
export const PERSONNEL_UPDATE_URL = `${API_URL}api/v1/definition/personnel/update/`;
export const PERSONNEL_GET_BY_USER_URL = `${API_URL}api/v1/definition/personnel/getByUserId/`;


export function createPersonnel(personnelData: IPersonnelModel) {
  return axios.post(PERSONNEL_CREATE_URL, personnelData);
}

export function updatePersonnel(personnel: IPersonnelModel) {
  return axios.patch(PERSONNEL_UPDATE_URL + personnel.id, personnel)
}

export async function loadPersonnels(
  page = 0,
  size = 5,
  sort: string = 'createdDate',
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<IPersonnelModel>>>> {
  return axios.get(PERSONNEL_GET_ALL_URL, {
    params: { page, size, sort, order }
  });
}

export function deletePersonnel(personnelId: string) {
  return axios.delete(PERSONNEL_DELETE_URL + personnelId);
}

export function getPersonnelByUserId(userId: string):Promise<AxiosResponse<ApiResponse<IPersonnelModel>>> {
  return axios.get(`${PERSONNEL_GET_BY_USER_URL}/${userId}`)
}




